import { get } from "../../../../logics/src/utils/helpers";
import { VERNACULAR_LANG_COOKIE_NAME } from "layouts/Payment/common/dependencies/constants";
import { getCookie } from "helpers/utils/cookie";
import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";
import { DEVICE_TYPE } from "constants/index";
import { isServer } from "helpers/utils/isServer";


const DEVICE_MODE = {
  DESKTOP: "desktop",
  MOBILE: "mobile",
};

export const getGenericMessage = (deviceMode: string, pageName?: string) => {
  let message = {};
  try {
    let deviceType = DEVICE_MODE.MOBILE;

    if (deviceMode == DEVICE_TYPE.DESKTOP) {
      deviceType = DEVICE_MODE.DESKTOP;
    }

    let enabledForDevice = false;
    let enabledForPage = false;
    if (!pageName) {
      pageName = "paymentPage";
    }

    if (!isServer()) {
      const { remoteConfig } = window as any;
      enabledForDevice = get(remoteConfig, `switches.genericMessageBar.configs.${deviceType}.status`);
      enabledForPage = get(remoteConfig, `switches.genericMessageBar.configs.${deviceType}.${pageName}.status`);

      if (enabledForDevice && enabledForPage) {
        let vernacularLang = getCookie(VERNACULAR_LANG_COOKIE_NAME);
        if (vernacularLang) {
          message = get(remoteConfig, `switches.genericMessageBar.configs.${deviceType}.${pageName}.${vernacularLang}`);
        } else {
          message = get(remoteConfig, `switches.genericMessageBar.configs.${deviceType}.${pageName}.en`);
        }

        if (!message) {
          message = get(remoteConfig, `switches.genericMessageBar.configs.${deviceType}.${pageName}`);
        }
      }
    }

    return message;
  } catch (error) {
    return message;
  }
};

// function that returns pro warning text from remoteconfig
export const getProWarningText = () => {
  let message = "";
  try {
    if (!isServer()) {
      const { remoteConfig } = window as any;
      // returning pro warning text from config
      message = get(remoteConfig, "configs.proWarningText");
    }
    return message;
  } catch (error) {
    return message;
  }
};


export const getGuestLoginPageText = () => {
  const guestLoginPageText = {
    login: {
      heading: VERNACULAR_DEFAULT_MESSAGES.HAVE_ACCOUNT,
      subHeading: VERNACULAR_DEFAULT_MESSAGES.LOG_IN_SUB_TITLE,
    },
    signup: {
      heading: VERNACULAR_DEFAULT_MESSAGES.NEW_NYKAA,
      subHeading: VERNACULAR_DEFAULT_MESSAGES.SIGN_UP_SUB_TITLE,
    },
    continueAsGuest: {
      heading: VERNACULAR_DEFAULT_MESSAGES.CHECKOUT_GUEST,
      subHeading: VERNACULAR_DEFAULT_MESSAGES.CHECKOUT_SUB_TITLE,
    },
  };

  return guestLoginPageText;
};
